const ninaMarketState = {
  market: {
    status: "Open",
    mood: "Bullish",
    bias: "Long",
    confidence: 91,
    riskLevel: "Low",
    bestTradingWindow: "9:45 AM – 11:15 AM",
    summary: "Buyers remain in control across major indexes.",

    session: "New York",
    phase: "Morning Momentum",
    liquidity: "Healthy",
    breadthStatus: "Positive",
    volatilityEnvironment: "Controlled",
  },

  indexes: {
    spy: {
      symbol: "SPY",
      change: 0.42,
      trend: "Bullish",
      aboveVwap: true,
    },

    qqq: {
      symbol: "QQQ",
      change: 0.58,
      trend: "Strong",
      aboveVwap: true,
    },

    iwm: {
      symbol: "IWM",
      change: -0.21,
      trend: "Mixed",
      aboveVwap: false,
    },

    vix: {
      symbol: "VIX",
      value: 17.22,
      trend: "Low",
    },
  },

  marketMetrics: {
    institutionalFlow: {
      value: "Buying",
      score: 88,
    },

    momentum: {
      value: "Strong",
      score: 84,
    },

    breadth: {
      value: "Positive",
      score: 86,
    },

    volatility: {
      value: "Low",
      score: 42,
    },
  },

  leadership: {
    bestSector: "Technology",
    secondSector: "Energy",
    weakestSector: "Utilities",
    strategy: "Follow Strength",
  },

  currentTrade: {
    symbol: "PLUG",
    company: "Plug Power",
    grade: "A+",
    stage: "Ready",
    confidence: 94,
    setup: "Pullback setup forming near VWAP support",
    direction: "Long",

    currentPrice: 6.42,
    dayHigh: 6.58,
    dayLow: 6.12,
    vwap: 6.35,
    ema20: 6.39,

    entry: 6.42,
    stop: 6.3,

    targets: {
      target1: 6.6,
      target2: 6.82,
      target3: 7.0,
    },

    riskReward: "1 : 4",

    tradeStatus: "Waiting for confirmation",
    confirmationRequired: true,
    extended: false,
    chasingRisk: "Moderate",
  },

  opportunities: [
    {
      symbol: "PLUG",
      company: "Plug Power",
      grade: "A+",
      confidence: 96,
      stage: "Ready",
      trend: "Bullish",
      entry: 6.42,
      stop: 6.3,
      target1: 6.6,
      target2: 6.82,
      target3: 7.0,
      riskReward: "1 : 4",
      catalyst: "Energy + AI",
      reason:
        "VWAP support with increasing volume and improving momentum.",
      rank: 1,
      momentumScore: 99,
      institutionalActivity: "Strong",
    },

    {
      symbol: "UEC",
      company: "Uranium Energy",
      grade: "A",
      confidence: 91,
      stage: "Swing",
      trend: "Bullish",
      entry: 9.85,
      stop: 9.6,
      target1: 10.25,
      target2: 10.6,
      target3: 10.95,
      riskReward: "1 : 3",
      catalyst: "Uranium Strength",
      reason:
        "Sector momentum remains strong while buyers defend support.",
      rank: 2,
      momentumScore: 93,
      institutionalActivity: "Strong",
    },

    {
      symbol: "RXT",
      company: "Rackspace Technology",
      grade: "A",
      confidence: 88,
      stage: "Pullback",
      trend: "Bullish",
      entry: 6.18,
      stop: 6.04,
      target1: 6.36,
      target2: 6.55,
      target3: 6.72,
      riskReward: "1 : 2.8",
      catalyst: "Support Reclaim",
      reason:
        "Controlled pullback is forming near an important support zone.",
      rank: 3,
      momentumScore: 90,
      institutionalActivity: "Building",
    },
  ],

  ninaVerdict: {
    action: "Wait for Pullback",
    decision: "Wait",
    explanation:
      "Buyers remain in control. Do not chase momentum. The best setup is a pullback into VWAP with volume confirmation.",

    confidence: 91,
    urgency: "Patient",
    tradePermission: "Confirmation Required",
    preferredDirection: "Long",
    invalidation:
      "Bullish conditions weaken if SPY loses VWAP and buying volume fades.",
  },

  commentary: [
    "SPY remains above VWAP.",
    "QQQ continues leading technology.",
    "Small caps are improving.",
    "Buying pressure remains healthy.",
    "Long setups are currently favored.",
  ],

  /*
   * NINA SHARED INTELLIGENCE
   * This section becomes the common reasoning source for every dashboard
   * component during the demo.
   */

  ninaIntelligence: {
    status: "Active",
    mode: "Live Demo Simulation",
    state: "Monitoring Pullback",
    confidence: 91,

    primaryObservation:
      "Major indexes remain constructive while PLUG holds above VWAP support.",

    currentConclusion:
      "The market supports long setups, but the current candle should not be chased.",

    recommendedAction:
      "Wait for a controlled pullback and a green confirmation candle with improving volume.",

    nextBestAction:
      "Monitor PLUG near $6.35–$6.42 and enter only after support is confirmed.",

    riskMessage:
      "Avoid entering if price becomes extended above VWAP or loses $6.30 support.",

    opportunityFocus: {
      symbol: "PLUG",
      reason:
        "Highest-ranked opportunity with bullish alignment, defined risk, and strong institutional participation.",
      stage: "Confirmation Required",
      priority: "High",
    },
  },

  liveReasoning: {
    headline: "AI Assistant is waiting for confirmation",

    summary:
      "Buyers are defending VWAP and market conditions remain bullish. Momentum is improving, but the safest entry is after a controlled pullback confirms support.",

    detailedExplanation:
      "SPY and QQQ remain above VWAP while institutional flow favors technology and energy. PLUG continues holding near its planned entry zone with improving volume. The setup remains valid, but entering before confirmation would increase chasing risk.",

    reasoningSteps: [
      {
        id: 1,
        category: "Market",
        status: "Positive",
        message:
          "SPY and QQQ remain above VWAP, supporting the long market bias.",
      },

      {
        id: 2,
        category: "Sector",
        status: "Positive",
        message:
          "Technology and energy continue receiving the strongest capital flow.",
      },

      {
        id: 3,
        category: "Setup",
        status: "Positive",
        message:
          "PLUG is holding near VWAP support with a defined stop below structure.",
      },

      {
        id: 4,
        category: "Momentum",
        status: "Improving",
        message:
          "Volume and momentum are improving, but price confirmation is still required.",
      },

      {
        id: 5,
        category: "Risk",
        status: "Warning",
        message:
          "Do not chase an extended green candle above the planned entry zone.",
      },
    ],

    decisionFactors: {
      marketAlignment: 94,
      volumeStrength: 89,
      momentumQuality: 92,
      vwapPosition: 95,
      trendStrength: 91,
      riskRewardQuality: 94,
    },
  },

  confirmationSignals: [
    {
      id: "market-alignment",
      label: "Market Alignment",
      status: "Confirmed",
      score: 94,
      message: "SPY and QQQ support the current long bias.",
    },

    {
      id: "vwap-support",
      label: "VWAP Support",
      status: "Confirmed",
      score: 95,
      message: "PLUG remains above VWAP and buyers continue defending support.",
    },

    {
      id: "volume",
      label: "Volume",
      status: "Confirmed",
      score: 89,
      message: "Volume is increasing above the recent average.",
    },

    {
      id: "momentum",
      label: "Momentum",
      status: "Developing",
      score: 92,
      message: "Momentum is improving without becoming overextended.",
    },

    {
      id: "entry-candle",
      label: "Entry Candle",
      status: "Waiting",
      score: 68,
      message: "A clean confirmation candle is still required before entry.",
    },
  ],

  warningSignals: [
    {
      id: "do-not-chase",
      severity: "Medium",
      title: "Do Not Chase",
      message:
        "Price is near the planned entry zone. Wait for a pullback or confirmation candle.",
    },

    {
      id: "small-cap-divergence",
      severity: "Low",
      title: "Small-Cap Divergence",
      message:
        "IWM remains below VWAP, so broad small-cap participation is not fully confirmed.",
    },

    {
      id: "support-invalidation",
      severity: "High",
      title: "Support Invalidation",
      message:
        "The PLUG setup weakens if price loses the $6.30 stop level.",
    },
  ],

  sessionMemory: {
    sessionId: "demo-session-001",
    sessionDate: "Demo Trading Session",
    sessionStatus: "Active",

    openingCondition:
      "The market opened with bullish index alignment and controlled volatility.",

    firstObservation:
      "Buyers defended VWAP while technology and energy showed leadership.",

    currentEvolution:
      "Momentum improved after the open, but the AI Assistant has remained patient because price confirmation is incomplete.",

    importantEvents: [
      {
        time: "09:31",
        event: "Buyers began defending VWAP.",
        impact: "Positive",
      },

      {
        time: "09:33",
        event: "Volume increased above the recent average.",
        impact: "Positive",
      },

      {
        time: "09:35",
        event: "MACD improved, but confirmation remained incomplete.",
        impact: "Neutral",
      },

      {
        time: "09:37",
        event: "Price became vulnerable to chasing risk.",
        impact: "Warning",
      },

      {
        time: "09:39",
        event: "A pullback entry began forming near support.",
        impact: "Positive",
      },
    ],

    lessonsLearned: [
      "Bullish market conditions do not automatically justify an immediate entry.",
      "Waiting for confirmation improves execution quality.",
      "Defined risk remains more important than chasing momentum.",
    ],
  },

  marketChanges: [
    {
      id: 1,
      time: "09:31",
      type: "Market",
      previousState: "Mixed",
      currentState: "Bullish",
      message: "SPY reclaimed and held above VWAP.",
    },

    {
      id: 2,
      time: "09:33",
      type: "Volume",
      previousState: "Average",
      currentState: "Above Average",
      message: "Buying volume strengthened across leading sectors.",
    },

    {
      id: 3,
      time: "09:35",
      type: "Momentum",
      previousState: "Developing",
      currentState: "Improving",
      message: "Momentum strengthened without becoming fully extended.",
    },

    {
      id: 4,
      time: "09:39",
      type: "Trade Setup",
      previousState: "Watching",
      currentState: "Confirmation Required",
      message: "PLUG entered the planned monitoring zone near VWAP support.",
    },
  ],

  decisionHistory: [
    {
      id: 1,
      time: "09:31",
      decision: "Monitor",
      confidence: 82,
      reason:
        "Market direction improved, but the PLUG setup had not reached support.",
    },

    {
      id: 2,
      time: "09:33",
      decision: "Prepare",
      confidence: 87,
      reason:
        "Volume strengthened while buyers continued defending VWAP.",
    },

    {
      id: 3,
      time: "09:35",
      decision: "Wait",
      confidence: 89,
      reason:
        "Momentum improved, but the entry candle remained unconfirmed.",
    },

    {
      id: 4,
      time: "09:37",
      decision: "Do Not Chase",
      confidence: 92,
      reason:
        "Entering during candle extension would reduce the expected reward-to-risk ratio.",
    },

    {
      id: 5,
      time: "09:39",
      decision: "Wait for Pullback",
      confidence: 94,
      reason:
        "The preferred setup is developing near VWAP support, but confirmation is still required.",
    },
  ],

  demoTimeline: {
    enabled: true,
    simulationSpeed: "Normal",
    currentStep: 5,
    totalSteps: 7,

    steps: [
      {
        step: 1,
        time: "09:31",
        label: "VWAP Defense",
        status: "Complete",
      },

      {
        step: 2,
        time: "09:33",
        label: "Volume Increase",
        status: "Complete",
      },

      {
        step: 3,
        time: "09:35",
        label: "Momentum Improvement",
        status: "Complete",
      },

      {
        step: 4,
        time: "09:37",
        label: "Chasing Risk Detected",
        status: "Complete",
      },

      {
        step: 5,
        time: "09:39",
        label: "Pullback Forming",
        status: "Active",
      },

      {
        step: 6,
        time: "09:41",
        label: "Confirmation Candle",
        status: "Pending",
      },

      {
        step: 7,
        time: "09:43",
        label: "Trade Decision",
        status: "Pending",
      },
    ],
  },

  lastUpdated: "Updated just now",
};

export default ninaMarketState;